module.exports = __webpack_public_path__ + "media/apps/main/containers/portfolio/Export/Docx/helpers/SdgIcons/assets/sdg4-e441b2b3cfab22f82e7a2202316a0f5c.svg";